var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_nav",attrs:{"id":"about_nav"}},[_c('Tabs',{attrs:{"tabs":_vm.tabs,"currentTab":_vm.currentTab},on:{"onClick":_vm.handleTabClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }